module.exports = __webpack_public_path__ + "static/media/terms005.1b13ed6e.png";